import { blue } from "../../theme/colors";

/**
 * Table tokens copied from the lendmarq-los applications queue
 * (screens/SupportScreen/components/supportUi.jsx `T`) so this table keeps that
 * table's neutral weighting — its inks and hairlines are a touch warmer than
 * theme/colors' slate, and matching them is what keeps the two reading alike.
 *
 * The ACCENT is the exception: it comes from theme/colors' blue ramp. The
 * copied palette's accent was teal (#1798b4 / #21a9c4), which is Eastview's
 * brand, not Lendmarq's — see CLAUDE.md divergence #2. Neutrals may stay local;
 * brand color may not.
 */
const T = {
  action: blue[600],
  actionHover: blue[700],
  tint: blue[100],
  ink900: "#16242b",
  ink700: "#33454e",
  ink500: "#5d7079",
  ink300: "#9aaab1",
  line: "#e3e9ec",
  bg: "#f6f9fa",
  card: "#ffffff",
  amber: "#d97706",
  green: "#16a34a",
  slate: "#64748b",
  // The expanded row and its detail panel share this one tint so an open row
  // reads as a single block rather than a row with a card parked under it. It
  // covers a lot of surface, so it takes blue-50 rather than the blue-100 the
  // color system uses for a compact selected row.
  expandedBg: blue[50],
  groupBg: "#f8fafc",
  radius: "10px",
  shadow: "0 1px 2px rgba(22,36,43,.05), 0 4px 16px rgba(22,36,43,.05)",
};

export default T;
